import httpClient from "./httpClient";

/** @returns {Promise<{ stores: Array, coupons: Array }>} */
export const getSearchSuggestions = async (q, limit = 8, signal) => {
  const { data } = await httpClient.get("/search/suggestions", {
    params: { q, limit },
    signal,
  });
  return {
    stores: data.stores || [],
    coupons: data.coupons || [],
  };
};

/** @returns {Promise<string[]>} */
export const getSearchTrendingTerms = async () => {
  const { data } = await httpClient.get("/search/trending");
  return data.terms || [];
};
